<!--
 * @Author: ZS
 * @Date: 2020-06-09 15:37:50
 * @LastEditors: ZS
 * @LastEditTime: 2020-07-08 11:58:43
 * @Description: file content
-->
<template>
  <div class="header mainWidth clearfix">
    <div class="logo pull-left"
      :style="{ backgroundImage: `url(${sysLogo})` }"
    ></div>
    <div class="topLink pull-right"><a class="green" :href="schoolIndex" target="_Blank">学校首页</a>|
    <template v-if="problemFlag"><a class="green" :href="feedBackUrl" >意见反馈</a>|</template>
      <el-popover placement="bottom" width="240" trigger="hover">
        <div style="text-align:center">
          <img src="../../assets/images/time1.png" alt="" style="widt:80px;height:80px">
          <p style="line-height:36px;color:#666666">即将上线敬请期待~</p>
        </div>
        <a class="green" href="javascript:;" slot="reference">APP下载</a>
      </el-popover><span id="topLogin" v-if="!$store.state.isLogin">|<a class="green" href="javascript:;"
          @click="login(0)">登录</a></span><span id="logout" v-if="$store.state.isLogin">|<a class="green"
          href=" javascript:;" @click="login(1)">退出登录</a></span>
    </div>
  </div>
</template>

<script>
  import { request } from '@/api/axios'
  import { configList } from "@/api/feedBack.js";
  export default {
    data() {
      return {
        // 学校首页
        schoolIndex: "",
        // 系统logo
        sysLogo: "",
        // feedBackUrl: "http://campus.zzuli.edu.cn/portal-pc/pc/qy/feedBack/feedBack.html"
        feedBackUrl: "feedBack",
        problemFlag: true
      }
    },
    created() {
      this.getSysLogoAndIndex();
      this.configList();
    },
    methods: {
      /**
       * @name configList
       * @description 获取意见反馈的配置开关
       * @param {}
       * @return {}
       * @author cjs1992
       * @date 2020-08-24 10:57:38
       */
      async configList() {
        this.problemFlag = true;
        if (!this.$store.state.isLogin) {
          return;
        }
        const res = await configList();
        const list = res.data;
        for(let item of list) {
          if (item.moduleKey === "problem") {
            this.problemFlag = item.status === 1 ? true : false;
            break;
          }
        }
      },
      /**
       * @name getSysLogoAndIndex
       * @description 获取系统logo和学校首页地址
       * @param {}
       * @return {}
       * @author cjs1992
       * @date 2020-08-06 14:59:29
       */
      async getSysLogoAndIndex() {
        request({
          method: "get",
          url: "/portal-ywtb/web/portalPcGuidelineWebsiteInfo/findPortalPcGuidelineWebsiteInfoList"
        }).then((res) => {
          if (res && res.dataList && res.dataList[0]) {
            const { pcGuidelineWebsiteInfoImg, pcGuidelineWebsiteInfoUrl } = res.dataList[0];
            this.schoolIndex = pcGuidelineWebsiteInfoUrl;
            this.sysLogo = '/portal-ywtb/public/getImg?path=' + window.encodeURIComponent(pcGuidelineWebsiteInfoImg);
            this.$store.commit("changeWebInfo", res.dataList[0]);
          }
        }).catch((err) => {})
      },
      login(flag) {
        if (flag == 0) {
          // this.clearAllCookie()
          top.window.location = '/portal-ywtb/web/login?url=' + location.href;
        } else if (flag == 1) {
          // this.clearAllCookie()
          top.window.location = '/portal-ywtb/web/logout?url=' + location.href;
        }
        // this.$store.commit('changeLogin')
      },
      // 暂时不用了
      clearAllCookie() { //清除cookie
        // this.$cookies.set(key, value[, expireTimes[, path[, domain[, secure]]]])
        let token = 'asd1d5.0o9utrf7.12jjkht';
        // 设置cookie默认过期时间单位是1d(1天)
        this.$cookies.set('token', token, 1);
        console.log(this.$cookies.get('name'))
        var keys = document.cookie.match(/[^ =;]+(?==)/g)
        if (keys) {
          for (var i = keys.length; i--;) {
            document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString() // 清除当前域名下的,例如：m.ratingdog.cn
            document.cookie = keys[i] + '=0;path=/cas;domain=' + document.domain + ';expires=' + new Date(0)
              .toUTCString() // 清除当前域名下的，例如 .m.ratingdog.cn
            document.cookie = keys[i] + '=0;path=/portal-ywtb;domain=192.168.30.36;expires=' + new Date(0).toUTCString()
            // 清除一级域名下的或指定的，例如 .ratingdog.cn
          }
        }
      }

    },
    mounted() {
      // this.$store.commit('changeLogin')
    }
  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue